import { t } from 'i18next'

import { CAPMPAIGNS_FILTERS_KEYS, CAPMPAIGNS_STATUSES } from '../constants'

export const statusFilter = {
  keyState: CAPMPAIGNS_FILTERS_KEYS.status,
  placeholder: t('rm:filterByCampaignStatus'),
  options: CAPMPAIGNS_STATUSES
} as GenericFilterProps
